import {inject, Injectable} from "@angular/core";
import {DataService, NotificationService} from "@fgpp-ui/components";
import {FnUiDialogService} from "../../shared/fn-ui-dialog/services/fn-ui-dialog.service";
import {IGroupAction} from "./group-actions.service";
import {Observable, of, switchMap, map, catchError} from "rxjs";
import {AddNoteModalComponent, AddNoteModalFields} from "../../ui-components/add-note-modal/add-note-modal.component";
import  {ProfilesGroupActionsStrategyInterface} from "./profiles-group-actions-strategy.interface";
import {TranslateService} from "@ngx-translate/core";
import {ModalsService} from "../../shared/fn-ui-modals/services/modals.service";

@Injectable()
export class ProfilesGroupActionService implements ProfilesGroupActionsStrategyInterface {

  protected dataService =  inject(DataService);
  protected dialogService =  inject(FnUiDialogService);
  protected notificationService: NotificationService = inject(NotificationService);

/*  constructor(private dataService: DataService, private dialogService: FnUiDialogService) {
  }*/
  public getProfileGroupActions(profileId: string, selectedRows: any[]): Observable<any> {
    const url = 'do/PROFILE/' + profileId + '/groupActions';
    return this.dataService.getFromCache(url);
  }


  public executeProfileGroupActions(profileId: string, action: IGroupAction, recordsUniqueIds: Array<string>): Observable<any> {
    let note = null;
    const actionId = action.actionId ? action.actionId.toLowerCase().split(' ').join('_') : null;

    if (action.mandateNote) {
      const config: AddNoteModalFields = {
        title: 'group_action.add_note.' + actionId + '.title',
        body: 'group_action.add_note.' + actionId + '.body',
        closeButton: 'group_action.add_note.' + actionId + '.close_button',
        applyButton: 'group_action.add_note.' + actionId + '.ok_button',
      };

      const dialogRef = this.dialogService.open(AddNoteModalComponent, { data: config });
      return dialogRef.afterClosed().pipe(
        switchMap((note) => {
          if (!note || note === '') {
            return of(null);
          }
          const payload = {
            action: action.actionId,
            uids: recordsUniqueIds,
            profileId: profileId,
            note: note
          };
          return this.dataService.post('do/PROFILE/' + profileId + '/performGroupAction', payload).pipe(
            map((response) => {
              if (response && response.errorCode) {
                return { message: response.errorCode };
              }
              if (response.errorMessage.includes('failed')) {
                this.notificationService.error(response.errorMessage);
              } else {
                this.notificationService.success(response.errorMessage);
              }
              return of({});
            }),
            catchError((error) => {
              if (error && error.errorCode && error.errorMessage) {
                return of({ code: error.errorCode, message: error.errorMessage });
              }
              return of(null);
            })
          );
        })
      );
    }

    return of(null);
  }
}
